import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { AuthService } from '@core/services/auth.service';
import { ModalUtilsService } from '@core/services/modal-utils.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslatePipe } from '@ngx-translate/core';
import { DeleteDialogComponent } from '@shared/components/delete-dialog/delete-dialog.component';
import { AuctionBidInfo } from 'src/app/articles-manager/interfaces/auction.interface';
import { AuctionViewService } from 'src/app/articles-manager/services/auction-view.service';

@Component({
  selector: 'app-article-offers-dialog',
  templateUrl: './article-offers-dialog.component.html',
  styleUrls: ['./article-offers-dialog.component.scss'],
  standalone: true,
  imports: [DatePipe, TranslatePipe, FaIconComponent],
})
@UntilDestroy()
export class ArticleOffersDialogComponent implements OnInit {
  auctionBidInfo = signal<AuctionBidInfo | null>(null);
  idAuction = signal<number | null>(null);

  bids = signal<AuctionBidInfo | null>(null);
  auctionBidHistoryList = computed(
    () => this.bids()?.auctionBidHistoryList ?? []
  );
  totalBids = computed(() => this.bids()?.totalBids ?? 0);
  totalBidder = computed(() => this.bids()?.totalBidder ?? 0);

  faTrash = faTrash;

  public activeModal = inject(NgbActiveModal);
  authService = inject(AuthService);
  private readonly modalUtils = inject(ModalUtilsService);
  private readonly _api = inject(ApiService);
  private readonly auctionViewService = inject(AuctionViewService);

  constructor() {
    effect(
      () => {
        if (!this.idAuction()) return;
        if (this.bids()) return;

        this.loadData();
      },
      {
        allowSignalWrites: true,
      }
    );
  }

  ngOnInit(): void {}

  loadData() {
    this.auctionViewService
      .getHistory(this.idAuction())
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.bids.set(response);
      });
  }

  deleteOffer(idBid: number) {
    if (!this.idAuction()) return;

    const refDelete = this.modalUtils.openModal(DeleteDialogComponent, {
      size: 'sm',
      keyboard: false,
    });
    refDelete.result.then((resultDelete) => {
      if (resultDelete === '1') {
        this._api
          .request(ApiServiceHolder.auction.deleteBid(idBid))
          .subscribe(() => {
            this.loadData();
          });
      }
    });
  }
}
